export default __webpack_public_path__ + "static/media/ai.13f56558.svg";